import React from 'react';

export const BeforeEngineerVisitAccordion: React.FC = () => (
  <ul>
    <li>
      <h5>Make sure you’ve chosen the best date and time. </h5>
      If you need to rearrange, you can do so up to 12noon on the day before your engineer visit.
    </li>
    <li>
      <h5>Get permission from the property owner for possible engineering work. </h5>
      For example, the engineer may need to carry out drilling or secure ladders. Rest assured, we’ll leave everything
      clean and tidy afterwards!
    </li>
    <li>
      <h5>Make sure you have a power socket near to where you want us to install your equipment.</h5>
    </li>
    <li>
      <h5>
        Make sure you have a decision maker on-site for the whole engineer visit – and provide their contact details to
        the engineer.&nbsp;
      </h5>
      It’s important that the engineer can get in touch if they need to. Engineer visits usually take two hours or
      longer.
    </li>
  </ul>
);
